import { SignInFormActions } from './signInFormActions';

const initialState = {
    passwordExpired: false,
    rememberMe: true,
};

export const signInFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case SignInFormActions.SIGN_IN_START: {
            return {
                ...state,
                signingIn: true,
                signedIn: false,
                validationError: null,
            };
        }

        case SignInFormActions.SIGN_IN_SUCCESS: {
            return {
                ...state,
                signingIn: false,
                signedIn: true,
                responseBody: action.responseBody,
                isProvider: action.isProvider,
                suggestedRedirect: action.suggestedRedirect,
            };
        }

        case SignInFormActions.SIGN_IN_FAILURE: {
            return {
                ...state,
                signingIn: false,
                signedIn: false,
                validationError: action.error,
            };
        }

        case SignInFormActions.ENTER_EMAIL: {
            return {
                ...state,
                email: action.email,
            };
        }

        case SignInFormActions.ENTER_PASSWORD: {
            return {
                ...state,
                password: action.password,
            };
        }

        case SignInFormActions.CLICK_REMEMBER_ME: {
            return {
                ...state,
                rememberMe: action.rememberMe,
            };
        }

        case SignInFormActions.SIGN_IN_RESET: {
            return {
                ...state,
                ...initialState,
                signingIn: false,
                signedIn: false,
                validationError: null,
            };
        }

        case SignInFormActions.SIGN_IN_PASSWORD_EXPIRED: {
            return {
                ...state,
                passwordExpired: true,
            };
        }

        default:
            return state;
    }
};
